import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CaseService } from '../../services/case.service';
import { SharedHttpService } from '../../services/shared-http.service';

@Component({
  selector: 'app-assign-owner',
  templateUrl: './assign-owner.component.html',
  styleUrls: ['./assign-owner.component.scss']
})
export class AssignOwnerComponent implements OnInit {
  @Input() eCaseId:any;

  usersArr: any;
  selectedUserId:any;
  roleId: any;
  constructor(private modalService: NgbModal,public route: Router,private sharedService: SharedHttpService, public caseService: CaseService, public toastr: ToastrService) { }


  ngOnInit(): void {
    this.loadDate();
  }
  loadDate(){
    this.roleId = this.sharedService.CurrentRoleId;

    this.sharedService.get(`api/Case/GetUsersForCase?eCaseId=${this.eCaseId}`).subscribe(res=>{
      this.usersArr = res;
    });

    
  }

  SaveAssignUser(){
    this.sharedService.get(`api/Case/AssignUserForCase?eCaseId=${this.eCaseId}&UserId=${this.selectedUserId}&RoleId=${this.roleId}`).subscribe(res => {
      this.sharedService.showSuccessKey("AssignedSaved");
      this.modalService.dismissAll();
      this.route.navigateByUrl('/refresh', { skipLocationChange: true }).then(() => {
          this.route.navigate([`details/case/${this.eCaseId}/cases`]);

    });
  });
  }
}
